var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXTwitter = function SvgXTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.6 0h2.454l-5.36 6.777L16 16h-4.937l-3.867-5.593L2.77 16H.316l5.733-7.25L0 0h5.063l3.495 5.113zm-.86 14.375h1.36L4.323 1.54H2.865z"
  })));
};
export default SvgXTwitter;